import { SxProps, Theme } from '@mui/material';

export const getInputSx = (hasStartIcon: boolean): SxProps<Theme> => ({
  '& .MuiOutlinedInput-root': {
    fontFamily: 'Inter',
    fontSize: { xs: '14px', sm: '16px' },
    '& fieldset': {
      borderColor: 'var(--color-border)',
      borderRadius: '8px'
    },
    '&:hover fieldset': {
      borderColor: 'var(--color-text-placeholder)'
    },
    '&.Mui-focused fieldset': {
      borderColor: 'var(--color-primary)',
      borderWidth: '1px'
    },
    '&.Mui-error fieldset': {
      borderColor: 'var(--color-error-red)'
    },
    '&.Mui-error:hover fieldset': {
      borderColor: 'var(--color-error-red)'
    },
    '&.Mui-error.Mui-focused fieldset': {
      borderColor: 'var(--color-error-red)'
    }
  },
  '& .MuiInputBase-input': {
    padding: hasStartIcon
      ? { xs: '10px 14px 10px 0', sm: '12px 16px 12px 0' }
      : { xs: '10px 14px', sm: '12px 16px' },
    color: 'var(--color-text-input)',
    '&::placeholder': {
      fontFamily: 'Inter',
      fontWeight: 400,
      fontSize: { xs: '14px', sm: '16px' },
      lineHeight: { xs: '20px', sm: '24px' },
      color: 'var(--color-text-placeholder)',
      opacity: 1
    }
  },
  '& .MuiInputAdornment-root': {
    color: 'var(--color-text-tertiary)'
  }
});

export const inputSx: SxProps<Theme> = getInputSx(false);

export const inputLabelSx: SxProps<Theme> = {
  fontFamily: 'Inter',
  fontWeight: 500,
  fontSize: { xs: '14px', sm: '14px' },
  lineHeight: { xs: '20px', sm: '20px' },
  color: 'var(--color-text-secondary)',
  marginBottom: '8px',
  display: 'block'
};

export const labelContainerSx: SxProps<Theme> = {
  width: '100%'
};

export const requiredAsteriskSx: SxProps<Theme> = {
  color: 'var(--color-text-secondary)',
  marginLeft: '4px'
};

export const errorMessageSx: SxProps<Theme> = {
  color: 'var(--color-error-red)', // Error red color to match Material-UI error state
  fontSize: '0.75rem', // 12px
  marginTop: '4px',
  marginLeft: '14px', // Aligns with input padding
  fontFamily: 'Inter',
  fontWeight: 400,
  lineHeight: '1.66', // Material-UI default FormHelperText lineHeight
  display: 'block'
};

